const EARTH_RADIUS_MI = 3958.8; // in miles

// Distance between two points (miles), Haversine formula
export function distanceMi(a, b) {
	if (!a || !b) return Infinity;

	const toRad = (deg) => (deg * Math.PI) / 180;
	const dLat = toRad(b.lat - a.lat);
	const dLng = toRad(b.lng - a.lng);

	const sinLat = Math.sin(dLat / 2);
	const sinLng = Math.sin(dLng / 2);

	const h =
		sinLat * sinLat +
		Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * sinLng * sinLng;

	return EARTH_RADIUS_MI * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
}

export function formatDistance(mi) {
	if (!Number.isFinite(mi)) return '';
	return `${mi.toFixed(2)} mi`;
}

// dealer in viewport
export function isWithinBounds({ lat, lng }, viewport) {
	if (!viewport) return false;
	const { north, south, east, west } = viewport;

	const latOk = lat <= north && lat >= south;
	const lngOk = west <= east ? lng >= west && lng <= east : lng >= west || lng <= east;

	return latOk && lngOk;
}